import React, { useState, useEffect } from "react";
import Loader from "components/Loader/Loader";

const ConfirmIncomeModal = ({ incomeConfirmModalState, setIncomeConfirmModalState, setExistingFormData, recitaId }) => {
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = React.useState({});
    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const { id, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const updateFormData = (id, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    }

    const setErrorForField = (field) => {
        setFormErrorData({ [field]: "error" });
    }

    const errors = {
        reportCurrency: "Please select formato de conversão",
    };

    const validationRules = {
        reportCurrency: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.reportCurrency,
        }
    };

    useEffect(() => {
        if (incomeConfirmModalState) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [incomeConfirmModalState]);


    const handleCancel = () => {
        setExistingFormData({});
        setIncomeConfirmModalState(false);
    }

    const handleApprove = () => {
        for (let field in validationRules) {
            const { validate, message } = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({ name: field, message: message });
                setErrorForField(field);
                return;
            }
        }
        setExistingFormData({});
        setIncomeConfirmModalState(false)
        window.open(`../reports/income-report?id=${recitaId}&currency=${formData.reportCurrency}`)
    };


    return (
        <>
            {incomeConfirmModalState ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Imprimir Confirmação</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{ overflowY: "auto", maxHeight: "70vh" }}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>
                                    <p>Gostaria de imprimir o relatório? Se sim, selecione o formato de conversão</p>

                                    <div className="flex space-x-6 items-center">
                                        {/* Orgão Field */}
                                        

                                        {/* Movimento Field */}
                                        <div className="flex flex-col w-full">
                                            <label
                                                className="text-sm dark:text-white ml-1.5 font-medium">Selecione o formato de conversão</label>
                                            <select
                                                className="w-full p-2.5 text-gray-800 bg-white/0 border rounded-lg shadow-sm outline-none dark:!border-white/10 dark:text-white"
                                                id="reportCurrency"
                                                value={formData.reportCurrency}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o formato de conversão</option>
                                                <option value="EUR">YJP PARA EUR PARA KWZ</option>
                                                <option value="USD">YJP PARA USD PARA KWZ</option>
                                                <option value="AKZ">KWZ</option>
                                            </select>
                                        </div>
                                    </div>                               

                                </div>

                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                    Não
                                    </button>
                                    <button
                                        onClick={handleApprove}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Sim
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>



                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default ConfirmIncomeModal;
